import { select } from 'redux-saga/effects';
import { STRING_KEYS } from '../../localizedStrings';

const RISK_FIELDS_IDS = {
  BIRTH_DATE: '1',
  MARITAL_STATUS: '8',
  PROFESSION: '13',
  INCOME_TYPE: '12',
  INCOME: '14',
  PAYMENT_FREQUENCY: '15',
  SENIORITY_MONTH: '11',
  SENIORITY_YEAR: '10',
  PHONE: '6',
};

const PERSONAL_DATA_FIELDS_ORDER = [
  RISK_FIELDS_IDS.BIRTH_DATE,
  RISK_FIELDS_IDS.MARITAL_STATUS,
  RISK_FIELDS_IDS.PROFESSION,
  RISK_FIELDS_IDS.INCOME_TYPE,
];

const INCOME_INFO_FIELDS_ORDER = [
  RISK_FIELDS_IDS.INCOME,
  RISK_FIELDS_IDS.PAYMENT_FREQUENCY,
];

const SENIORITY_INFO_FIELDS_ORDER = [
  RISK_FIELDS_IDS.SENIORITY_MONTH,
  RISK_FIELDS_IDS.SENIORITY_YEAR,
];

const RISK_FIELDS_PLACEHOLDERS = {
  [RISK_FIELDS_IDS.BIRTH_DATE]: STRING_KEYS.scoring.formField.birthDate,
  [RISK_FIELDS_IDS.MARITAL_STATUS]: STRING_KEYS.scoring.formField.maritalStatus,
  [RISK_FIELDS_IDS.PROFESSION]: STRING_KEYS.scoring.formField.profession,
  [RISK_FIELDS_IDS.INCOME_TYPE]: STRING_KEYS.scoring.formField.incomeType,
  [RISK_FIELDS_IDS.INCOME]: STRING_KEYS.scoring.formField.income,
  [RISK_FIELDS_IDS.PAYMENT_FREQUENCY]: STRING_KEYS.scoring.formField.paymentFrecuency,
  [RISK_FIELDS_IDS.SENIORITY_MONTH]: STRING_KEYS.scoring.formField.seniorityMonth,
  [RISK_FIELDS_IDS.SENIORITY_YEAR]: STRING_KEYS.scoring.formField.seniorityYear,
};

const getAndOrderFields = (riskFormRequirements, orderArray) => {
  const dataFields = [];

  orderArray.forEach((dataFieldId) => {
    const dataField = riskFormRequirements.find(riskFormRequirement => (riskFormRequirement.id === dataFieldId));
    dataFields.push(dataField);
  });

  return dataFields;
};

const normalizeRiskFormRequirementsChoices = (choices) => {
  const newChoices = [];

  choices.forEach((choice) => {
    const { id, valueName } = choice;

    newChoices.push({
      value: id,
      label: valueName,
    });
  });

  return newChoices;
};

const getLocalizedStrings = state => state.localizedStrings;

export function* normalizeRiskFormRequirements(riskFormRequirements) {
  const { localizedStrings } = yield select(getLocalizedStrings);
  const newRiskFormRequirements = [];


  riskFormRequirements.forEach((riskFormRequirement) => {
    const { choices, id, regularExpresion } = riskFormRequirement;
    const placeholder = localizedStrings[RISK_FIELDS_PLACEHOLDERS[id]];
    let newChoices = choices;

    let type = 'input';
    let typeField = null;
    if (RISK_FIELDS_IDS.BIRTH_DATE === id) {
      typeField = 'date';
    } else if (RISK_FIELDS_IDS.SENIORITY_YEAR === id) {
      typeField = 'number';
    }

    if (choices && Array.isArray(choices)) {
      type = 'select';
      newChoices = normalizeRiskFormRequirementsChoices(choices);
    } else if (regularExpresion === '^1$') {
      type = 'checkbox';
    }

    newRiskFormRequirements.push({
      id,
      options: newChoices,
      pattern: regularExpresion,
      type,
      placeholder,
      typeField,
    });
  });

  const personalDataFields = getAndOrderFields(newRiskFormRequirements, PERSONAL_DATA_FIELDS_ORDER);
  const incomeInfoFields = getAndOrderFields(newRiskFormRequirements, INCOME_INFO_FIELDS_ORDER);
  const seniorityInfoFields = getAndOrderFields(newRiskFormRequirements, SENIORITY_INFO_FIELDS_ORDER);

  return {
    personalDataFields,
    incomeInfoFields,
    seniorityInfoFields,
  };
}

export const normalizeRiskEvaluationInfoParams = (riskEvaluationInfo, contactPhone) => {
  const newRiskEvaluationInfo = [];

  riskEvaluationInfo.forEach((riskEvaluationElement) => {
    const { id, inputType, value } = riskEvaluationElement;
    const newRiskEvaluationElement = {
      id,
    };

    if (inputType === 'select') {
      newRiskEvaluationElement.chosenId = value;
    }

    if (inputType === 'input') {
      newRiskEvaluationElement.value = value;
    }

    newRiskEvaluationInfo.push(newRiskEvaluationElement);
  });

  newRiskEvaluationInfo.push({
    id: RISK_FIELDS_IDS.PHONE,
    value: contactPhone,
  })

  return newRiskEvaluationInfo;
};
